export const clickCiApiUrl = process.env.REACT_APP_CLICKCI_API_URL
  ?? (process.env.NODE_ENV === 'development' ? 'http://localhost:8480' : '');
